<template>
  <div class="serviceadvantages-layout">
    <div class="serviceadvantages-header">
      <navbar classname="home"></navbar>
      <serviceheader></serviceheader>
    </div>
    <div class="serviceadvantages-main">
      <servicetable></servicetable>
    </div>
    <div class="serviceadvantages-footer">
      <Footer name="serviceadvantages"></Footer>
    </div>
  </div>
</template>
<script setup>
import navbar from "@/components/navbar.vue";
import Footer from "@/components/footer.vue";
import serviceheader from "@/views/homeview/serviceprocess/serviceheader.vue";
import servicetable from "@/views/homeview/serviceprocess/servicetable.vue";
</script>

<style lang="scss" scoped>
.serviceadvantages-layout {
  background: #f7f7f7;
  // margin: 0 auto;
  width: 100%;
  margin: 0 auto;
  box-sizing: border-box;
  @media screen and (max-width: 768px) {
  }
  @media screen and (min-width: 769px) and (max-width: 1200px) {
  }
  @media screen and (min-width: 1201px) and (max-width: 2600px) {
    .serviceadvantages-header {
      width: 100%;
      margin: 0 auto;
      // height: 588px;
      height: 742px;
      box-sizing: border-box;
      // background-color: yellow;
      // width: 88%;
      // margin: 0 auto;
      background: #000 url(@/assets/image/homeview/banner-service.png) no-repeat
        center/cover;
    }
    .serviceadvantages-main {
      width: 100%;
      position: relative;
    }
    .serviceadvantages-footer {
      background: #f7f7f7;
      width: 100%;
      height: auto;
    }
  }
}
</style>
